import {DefaultPluginConfig, PluginConfigPosition, registerPlugin} from "../lib/plugin";

export interface TextConfig extends DefaultPluginConfig, PluginConfigPosition {
    name: string
    align: 'left'|'center'|'right'
    size: number
    family: string
    weight: 'normal'|'bold'
    color: string
}

const render = (id: string, config: any, parentNode = null) => {
    if (!parentNode) {
        parentNode = document.body
    }
    if (typeof document === 'undefined') {
        return
    }
    let field = document.getElementById('plugin--name--' + id)
    if (field) {
        parentNode = field.parentNode
        field.parentNode.removeChild(field)
    }

    console.log('RENDER TEXT', config, parentNode)
    if (!config.enabled) {
        return
    }

    if (!config.name.trim()) {
        return
    }

    field = document.createElement('div')
    field.id = 'plugin--name--' + id
    if (parentNode === document.body) {
        field.style.position = 'absolute'
    }
    field.style.fontSize = `${config.size}px`
    field.style.fontFamily = config.family
    field.style.fontWeight = config.weight
    field.style.color = config.color
    field.style.textAlign = config.align

    if (config.horizontal === 'left') {
        field.style.left = `${config.horizontalSpace}px`
    } else {
        field.style.right = `${config.horizontalSpace}px`
    }

    if (config.vertical === 'top') {
        field.style.top = `${config.verticalSpace}px`
    } else {
        field.style.bottom = `${config.verticalSpace}px`
    }

    field.innerHTML = config.name
    parentNode.appendChild(field)
}

registerPlugin<TextConfig>('text', 'Text', {
    defaultSettings: [ "enabled", "name", "align", "horizontal", "vertical", "horizontalSpace", "verticalSpace" ],

    supports: ["position"],

    settings: {
        enabled: {
            title: 'enabled',
            type: 'check',
            defaultValue: true,
        },
        name: {
            title: 'text',
            type: 'string',
            defaultValue: 'My Tip-Menu',
        },
        align: {
            title: 'Alignment',
            type: 'select',
            options: ['left', 'center', 'right'],
            defaultValue: 'left',
        },
        size: {
            title: 'Size',
            type: 'number',
            defaultValue: 26,
        },
        family: {
            title: 'Font-Family',
            type: 'select',
            options: ['serif', 'sans-serif'],
            defaultValue: 'sans-serif',
        },
        weight: {
            title: 'Font weight',
            type: 'select',
            options: ['normal', 'bold'],
            defaultValue: 'bold',
        },
        color: {
            title: 'Color',
            type: 'color',
            defaultValue: '#b11b71',
        },
    },

    initialize: (id, config, parentNode) => {
        console.log('name plugin init', id, config, parentNode)
        render(id, config, parentNode)
    },

    onConfig: (id, config) => {
        console.log('name plugin config', id, config)
        render(id, config)
    },

    onRemove: (id) => {
        console.log('removing name plugin', id)
        let field = document.getElementById('plugin--name--' + id)
        if (field) {
            field.parentNode.removeChild(field)
        }
    },

    onWsAction: () => false
})